module.exports = "https://bin.bnbstatic.com/_next/static/images/Andrew Bit-890e2796ce1beea771616af18eb93022.jpg";